import { type ReactNode } from 'react'
import { DetailsHeader } from '@/features/admin/components/DetailsHeader'
import styles from './ScopeChangeRequestDetailsPanel.module.css'

export interface ScopeChangeRequestDetailsPanelProps {
  onClose: () => void
  /**
   * The panel's sections.
   */
  children?: ReactNode
}

export function ScopeChangeRequestDetailsPanel({
  onClose,
  children,
}: ScopeChangeRequestDetailsPanelProps) {
  return (
    <div className={styles.root}>
      <DetailsHeader onClose={onClose} />
      {children}
    </div>
  )
}
